<template>
  <div>
    <nav-header v-bind:showSearch="p_showSearch" v-bind:loginModalFlag="p_loginModalFlag" v-on:showLoginModal="p_showLoginModal" v-on:closeLoginModal="p_closeLoginModal"></nav-header>
    <nav-bread ref="child"></nav-bread>
    <div class="container">
      <div class="title_wrap">
        <p class="title_small">上海市临床检验中心</p>
        <p class="title_big">
          关于开展新型冠状病毒（2019-nCoV）
          <br/>
          呼吸道病原体检测申请
        </p>
      </div>
      <div style="padding:0 20%;">
        <el-form ref="applyForm" :model="form" size="small" :rules="formRule">
          <el-form-item prop="companyName">
            <label>单位名称</label>
            <div>
              <el-input v-model="form.companyName"></el-input>
            </div>
          </el-form-item>

          <el-form-item prop="address">
            <label>地址</label>
            <div>
              <el-input v-model="form.address"></el-input>
            </div>
          </el-form-item>

          <el-form-item prop="name">
            <label><span>*</span>联系人</label>
            <div>
              <el-input v-model="form.name"></el-input>
            </div>
          </el-form-item>

          <el-form-item prop="mobile">
            <label><span>*</span>联系电话</label>
            <div>
              <el-input v-model="form.mobile"></el-input>
            </div>
          </el-form-item>

          <el-form-item prop="position">
            <label>职位</label>
            <div>
              <el-input v-model="form.position"></el-input>
            </div>
          </el-form-item>

          <el-form-item prop="num">
            <label>检测人数</label>
            <div>
              <el-input v-model="form.num"></el-input>
            </div>
          </el-form-item>

          <el-form-item prop="remark">
            <label>备注</label>
            <div>
              <el-input v-model="form.remark"></el-input>
            </div>
          </el-form-item>

<!--          <el-form-item prop="medicalLicense">-->
<!--            <label><span>*</span>医疗机构执业许可证</label>-->
<!--            <div>-->
<!--              <el-upload class="upload"-->
<!--                 action="https://xcx.liferiverdx.com/hpv/upload/unlogin"-->
<!--                 :show-file-list="false"-->
<!--                 :before-upload="() => uploadLoading = 'medicalLicense'"-->
<!--                 :on-success="(resp, file) => uploadChange(resp, file, 'medicalLicense')"-->
<!--                 :on-error="(resp, file) => uploadChange(resp, file, 'medicalLicense')">-->
<!--                <el-input :disabled="true" :prefix-icon="uploadIcon('medicalLicense')" placeholder="上传文件" v-model="form.medicalLicense_label"></el-input>-->
<!--              </el-upload>-->
<!--            </div>-->
<!--          </el-form-item>-->

<!--          <el-form-item prop="powerOfAttorney">-->
<!--            <label><span>*</span>医疗机构授权同意书</label>-->
<!--            <div>-->
<!--              <el-upload class="upload"-->
<!--                 action="https://xcx.liferiverdx.com/hpv/upload/unlogin"-->
<!--                 :show-file-list="false"-->
<!--                 :before-upload="() => uploadLoading = 'powerOfAttorney'"-->
<!--                 :on-success="(resp, file) => uploadChange(resp, file, 'powerOfAttorney')"-->
<!--                 :on-error="(resp, file) => uploadChange(resp, file, 'powerOfAttorney')">-->
<!--                <el-input :disabled="true" :prefix-icon="uploadIcon('powerOfAttorney')" placeholder="上传文件" v-model="form.powerOfAttorney_label" clearable></el-input>-->
<!--              </el-upload>-->
<!--            </div>-->
<!--          </el-form-item>-->

          <el-form-item style="display:flex;justify-content: center;margin:35px 0 50px 0">
            <el-button type="" style="padding:9px 50px" @click="$router.back()">返 回</el-button>
            <el-button type="primary" style="padding:9px 50px" @click="submit" :disabled="uploadLoading">提 交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- <nav-footer></nav-footer> -->

  </div>

</template>

<script>
    import axios from 'axios'
    import "./../assets/css/base.css";
    import "@/assets/css/index.css?version=1.0.1";
    import NavHeader from "@/components/Header.vue";
    import NavFooter from "@/components/Footer.vue";
    import NavBread from "@/components/Bread.vue";
    import {getCookie} from "@/util/util.js"
    import 'babel-polyfill'

    export default {
        name: "qualityApply",
        data() {
            return {
                uploadLoading: null,
                form: {},
                p_showSearch: true,
                p_loginModalFlag: false,
                formRule: {
                    name: [ { required: true, trigger: 'blur', message: '请填写联系人', min: 1, max: 15} ],
                    mobile: [ { required: true, trigger: 'blur', message: '请填手机号', min: 1, max: 15} ],

                    // medicalLicense: [ { required: true, trigger: 'blur', message: '请上传医疗机构执业许可证'} ],
                    // powerOfAttorney: [ { required: true, trigger: 'blur', message: '请上传医疗机构授权同意书'} ],
                }
            };
        },
        components: {
            NavHeader,
            NavFooter,
            NavBread
        },
        computed: {
            token (){
                return getCookie("_token")?getCookie("_token"):""
            },
            user () {
                return this.$store.state.user
            },
            uploadIcon () {
              return function (id) {
                return this.uploadLoading && this.uploadLoading === id ? 'el-icon-loading' : 'el-icon-upload2'
              }
            }
        },
        mounted(){
          this.$set(this.form, 'mobile', this.user.mobile)
        },
        methods: {
            p_showLoginModal () {
              this.p_loginModalFlag = true;
            },

            p_closeLoginModal () {
              this.p_loginModalFlag = false;
            },

            doOrder () {
              this.$message('正在研发中');
            },

            uploadChange (resp, file, key) {
              let { msg, code, type } = resp
              if (msg === 'success' && code === 0) {
                this.$message.success('上传成功')
                this.$set(this.form, `${key}_label`, file.name)
                this.$set(this.form, key, resp.url)
              } else {
                this.$message.error('上传失败')
                this.$set(this.form, `${key}_label`, '')
                this.$set(this.form, key, '')
              }
              this.$refs.applyForm.validateField(key)
              this.uploadLoading = null
            },

            submit () {
              this.$refs.applyForm.validate((valid) => {
                if (valid) {
                  this.uploadLoading = true
                  axios.post(`/jys/questionnaire/RespiratoryTract`,
                    this.form, {
                      headers: {
                        "Content-Type": "application/json",
                        'token': getCookie("_token")
                      }
                    }
                  ).then(({data}) => {
                    this.$confirm(data.code === 0 ? '您的申请已提交成功，我们审核通过后，会由专人与您联系，请保持电话畅通。' : '提交失败，请输入正确的数据', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: data.code === 0 ? 'success' : 'warning'
                    }).then(() => {
                      this.$router.go(-1)
                      window.open("https://pic.jianyanwang.com/upload/20200208/23de1538b1964aa89e76d56392ea4de7.jpg")
                    }).finally(() => this.uploadLoading = false)
                  })
                }
              })
            }
        }
    };
</script>

<style scoped >
  .container {
    width: 75%;
    margin-top: 15px;
    color: #000;
  }
  .title_wrap{
    width: 100%;
    margin: 60px 0;
  }
  .title_big{
    font-size: 16px;
    font-weight: bolder;
    margin: 15px 0;
  }
  .title_inline{
    width: 100%;
    float: left;
    height: 35px;
    line-height: 35px;
    margin-bottom: 15px;
    padding-left: 10px;
    border-left: 6px solid #00C5B0;
  }
  .content_wrap,
  .step_wrap{
    width: 100%;
    float: left;
  }
  .step_wrap{
    margin: 20px 0 150px 20px;
  }
  .introduce_info{
    width: 70%;
    float: left;
    line-height: 30px;
    text-indent: 28px
  }
  .introduce_img{
    width: 30%;
    float: left;
  }
  .introduce_img img{
    width: 100%;
  }
  .step_wrap li{
    position: relative;
    width: 100%;
    min-height: 200px;
    border-left: 3px solid #d6d6d6;
  }
  .step_wrap li div{
    width: 100%;
    margin-left: 50px;
  }
  .step_num{
    position: absolute;
    top: 0;
    left: -13px;
    color: #000;
    background-color: #d6d6d6;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 50%;
  }
  .step_title{
    width: 100%;
    padding-bottom: 15px;
    border-bottom: 1px solid #d6d6d6;
  }
  .step_info{
    padding: 15px 20px;
    color: #8b8b8b;
  }
  .step_btn{
    width: 100%;
    text-align: center;
    padding: 25px 0;
  }
  .step_btn a{
    display: block;
    padding: 8px 0;
    margin: 0 auto;
    width: 200px;
    color: #fff;
    background-color: #00C5B0;
    border-radius: 20px;
  }
  .step_active{
    background-color: #00C5B0;
    color: #fff;
  }
  .el-form-item label > span {
    color: red
  }
  /deep/ .upload .el-upload {display:block !important;}
  /deep/ .upload .is-disabled input {
    background:#fff !important;
    cursor: pointer !important;
    border-color: #ccc;color:#000
  }
</style>



// WEBPACK FOOTER //
// src/pages/ApplyForm_pro.vue